// src/components/Navbar.js
import React, { useState, useEffect } from 'react';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Navigation links
  const navLinks = [
    { name: 'Products', href: '#home' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'Features', href: '#features' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <>
      <nav
        initial={{ y: -100 }}
        animate={{ y: 0 }}
        className={`fixed w-full z-50 transition-all duration-300 ${
          isScrolled ? 'bg-dark-bg/80 backdrop-blur-lg shadow-lg' : ''
        }`}
      >
        <div className="container mx-auto px-4">
          <div className="flex items-center justify-between h-20">
{/* Compact Elegant Logo */}
<div
  whileHover={{ scale: 1.05 }}
  className="flex items-center space-x-1 cursor-pointer"
>
  <span className="text-xl font-black text-accent tracking-tight">
  NexaProxy
  </span>
  {/* <span className="px-2 py-0.5 text-[10px] font-medium bg-accent text-dark-bg rounded-full">
    v3.2
  </span> */}
</div>


            {/* Desktop Navigation */}
            <div className="hidden md:flex items-center space-x-8">
              {navLinks.map((link) => (
                <NavLink key={link.name} href={link.href}>
                  {link.name}
                </NavLink>
              ))}
            </div>

            {/* CTA Button */}
            <div className="hidden md:block">
  <button
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={() => window.open('https://headwayapp.co/nexaproxy-changelog', '_blank')}
    className="bg-accent hover:bg-accent-hover text-dark-bg px-6 py-2 rounded-xl font-medium transition-colors cursor-pointer"
  >
    Updates 
  </button>
</div>

            {/* Mobile Menu Button */}
            <div className="md:hidden">
              <button
                onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
                className="p-2 rounded-lg text-text-secondary hover:text-accent focus:outline-none"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {isMobileMenuOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}

        {isMobileMenuOpen && (
          <div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            className="fixed inset-x-0 top-20 z-40 md:hidden"
          >
            <div className="bg-dark-bg/95 backdrop-blur-lg border-b border-gray-800 shadow-lg">
              <div className="container mx-auto px-4 py-4">
                <div className="flex flex-col space-y-4">
                  {navLinks.map((link) => (
                    <a
                      key={link.name}
                      href={link.href}
                      onClick={() => setIsMobileMenuOpen(false)}
                      className="text-text-secondary hover:text-accent py-2 transition-colors"
                    >
                      {link.name}
                    </a>
                  ))}
  <button
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
    onClick={() => window.open('https://headwayapp.co/nexaproxy-changelog', '_blank')}
    className="bg-accent hover:bg-accent-hover text-dark-bg px-6 py-2 rounded-full font-medium transition-colors cursor-pointer"
  >
    Updates 🛎️
  </button>
                </div>
              </div>
            </div>
          </div>
        )}
    </>
  );
};

// NavLink component for desktop navigation
const NavLink = ({ href, children }) => (
  <a
    href={href}
    className="text-text-secondary hover:text-accent transition-colors font-medium"
    whileHover={{ scale: 1.05 }}
    whileTap={{ scale: 0.95 }}
  >
    {children}
  </a>
);

export default Navbar;